import { useEffect, useState } from 'react';

interface MatchScoreProps {
  score: number;
  size?: number;
}

export default function MatchScore({ score, size = 120 }: MatchScoreProps) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setMounted(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const strokeWidth = size * 0.08;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (score / 100) * circumference;

  const color =
    score >= 80
      ? 'var(--color-ti-green)'
      : score >= 60
        ? 'var(--color-ti-amber)'
        : 'var(--color-ti-red)';

  const textColor =
    score >= 80
      ? 'text-ti-green'
      : score >= 60
        ? 'text-ti-amber'
        : 'text-ti-red';

  return (
    <div className="flex flex-col items-center gap-2">
      <div className="relative" style={{ width: size, height: size }}>
        <svg
          width={size}
          height={size}
          viewBox={`0 0 ${size} ${size}`}
          className="-rotate-90"
        >
          {/* Background ring */}
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="none"
            stroke="var(--color-ti-border)"
            strokeWidth={strokeWidth}
          />
          {/* Score ring */}
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="none"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={mounted ? offset : circumference}
            style={{
              transition: 'stroke-dashoffset 1.2s cubic-bezier(0.4, 0, 0.2, 1)',
            }}
          />
        </svg>
        {/* Center score */}
        <div className="absolute inset-0 flex items-center justify-center">
          <span
            className={`font-bold ${textColor}`}
            style={{ fontSize: size * 0.3 }}
          >
            {score}
          </span>
        </div>
      </div>
      <span className="text-sm font-medium text-ti-text-muted uppercase tracking-wider">
        Match Score
      </span>
    </div>
  );
}
